
const path = require('path')
const sh = require('shelljs')
const fs = require('fs')
const reactDocs = require('react-docgen')
const generateDocsApp = require('../templates/docs_app')
const marked = require('marked')
// marked.setOptions({
//   renderer: new marked.Renderer(),
//   gfm: true,
//   tables: true,
//   breaks: false,
//   pedantic: false,
//   sanitize: false,
//   smartLists: true,
//   smartypants: false
// });

const {
    begin, finish, error,
    primary, accent, warn, newline,
    config, inquirer
} = require('../common.js')

/*

collect any markdown files.
collect any jsx files.

turn all of this into json,
dump into the docs folder as docs.json?

that folder should be responsible for turning that into html?

... or should the whole docs webapp be implemented here?

I basically want something like the lodash documentation.
There's a sidebar, a search bar, and pages for everything.

should there even be a server running? Why not just compile to static js and html? Actually, I can totally do that with any react app now. There needs to be a mini docs app...



Maybe there ought to be sections for each kind of doc supported?

models
services
actions

components

maybe start with components

go through the whole app, look for

<appName>/components/<componentName>/<componentName>.jsx

turn that into

{
    name: componentName,
    app: appName,
    created,
    updated,
    props: {
        "propName": {
            type: "number",
            value // for custom/special types,
            required,
            default,
            description, // taken from comments directly above
        },
    }
}

<appName>/components/<componentName>/<componentName>.md



*/

module.exports = yargs => {
    begin('docs')

    const rootPath = config.get('ops_client_path')
    const pkgPath = path.join(rootPath, 'package.json')

    let pkg

    try {
        pkg = JSON.parse(fs.readFileSync(pkgPath, 'utf8'))
    } catch (err) {
        error('docs', 'unable to read client package.json')
    }

    getComponentsJSON(rootPath, pkg.apps)

}


function getComponentsJSON(rootPath, apps) {

    console.log(`\tparsing ops components\n`)

    const result = {}

    // go through every registered app
    apps.forEach(app => {

        result[app.name] = []
        // console.log(`\tchecking ${accent(app.name)}`)
        let components

        try {
            components = fs.readdirSync(path.join(
                rootPath,
                app.name,
                'components'
            ))
        } catch (err) {
            error('docs', `${app.name} does not have a components directory`)
            return
        }


        for (let i in components) {

            let component
            // TO DO - catch md files
            try {

                component = fs.readFileSync(path.join(
                    rootPath,
                    app.name,
                    'components',
                    components[i],
                    `${components[i]}.jsx`
                ), 'utf8')

                component = reactDocs.parse(component)

                component.displayName = components[i]

                // If there is a markdown, read it as a string and attach it
                if (fs.existsSync(path.join(
                    rootPath,
                    app.name,
                    'components',
                    components[i],
                    `${components[i]}.md`
                ))) component.description = marked(fs.readFileSync(path.join(
                    rootPath,
                    app.name,
                    'components',
                    components[i],
                    `${components[i]}.md`
                ), 'utf8'))

                // console.log(`\t  > ${accent(components[i])}`)

                // TO DO - test for nested components

            } catch (err) {
                // console.log(`\tskipped ${warn(components[i])}`)
                // error('docs', `ops cannot create docs from ${component}`)
                continue
            }

            result[app.name].push(component)
        }

        // newline()

    })

    writeDocsApp(rootPath, result)

}

function writeDocsApp(rootPath, json) {

    console.log('\tcompiling docs app\n')

    const docsPath = path.join(rootPath, 'docs', 'index.html')
    const docs = generateDocsApp(json)

    try {
        sh.exec('rm -f ' + docsPath)
        fs.writeFileSync(docsPath, docs, 'utf8')

    } catch (err) {
        error('docs', `ops cannot write to ${docsPath}`)
        return
    }

    offerOpen(docsPath)
}

function offerOpen(docsPath) {

	inquirer
		.prompt([{
			type: 'confirm',
			name: 'open',
			message: `open now?`
		}])
		.then(({ open }) => {
			if (open) {
                sh.exec(`open ${docsPath}`)
            } else {
                console.log('\n\tgenerated docs can be found at:\n')
                console.log(`\t${primary(docsPath)}`)
            }
            finish()
		})
}



// WEBPACK FOOTER //
// ./src/commands/docs.js